import { Chat } from '@mui/icons-material';
import { formatTranslation } from 'intl';
import { UserTranslationKeys } from 'intl/keys';
import { Box, Chip } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { mentionUserChipStyle } from './styles';

export const CreateEventWithMentionedUserChip = ({
  setEventDialogOpen,
}: {
  setEventDialogOpen: (open: boolean) => void;
}): React.ReactElement => {
  const intl = useIntl();

  return (
    <Box>
      <Chip
        variant='outlined'
        label={formatTranslation(intl, UserTranslationKeys.mentionUser)}
        sx={mentionUserChipStyle}
        icon={<Chat fontSize='small' />}
        onClick={() => setEventDialogOpen(true)}
      />
    </Box>
  );
};
